import React from "react";
function Footer() {
  return (
    <>
      <a href="https://github.com/annastmal/WeatherApp" target="blank">
        {" "}
        Open-source coded by Anna Malanchuk
      </a>
    </>
  );
}
export default Footer;
